export const handleFileNameInputClick = (event) => {
  event.stopPropagation();
};
